import { Button, get as themeGet } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

const ManageActionButton = styled(Button)`
  width: 100%;
  margin: 0;
  padding: 0;
  &:focus,
  &:hover {
    text-decoration: none;
    span.caret svg path {
      fill: ${themeGet('colors.bmtBlue')};
    }
  }
`;

export default ManageActionButton;
